import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation, } from "react-router-dom";
import { Table } from 'antd';
import { MdArrowBack } from "react-icons/md";
import { useGetAudiencePatientMutation } from '../../redux/slices/patientSlice';

const Audienceuser = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [audienceData, setaudienceData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);
    const [getAudiencePatient, { isLoading }] = useGetAudiencePatientMutation();
    const { AudienceId } = location.state || {};
    const handleGoBack = () => {
        navigate(-1);
    };

    const getAudienceList = (query, AudienceId) => {
        getAudiencePatient({query, id:AudienceId})
            .then((res) => {
                const Pareseddata = JSON.parse(res.data.audience);
                const formattedData = Pareseddata.map((item) => ({
                    key: item.id,
                    first_name: item.first_name,
                    email: item.email,
                }));
                setaudienceData(formattedData);
            })
            .catch((err) => {
                console.error("err", err);
            });
    }


    useEffect(() => {
        let query = "";
        if (sortField && sortOrder) {
            query += `?sort_by=${sortField}&sort_order=${sortOrder}`;
        }
        getAudienceList(query, AudienceId);
    }, [currentPage, pageSize, sortField, sortOrder, AudienceId]);

    const tableColumns = [
        {
            title: "S.No",
            key: "serial_number",
            render: (text, record, index) => {
                return <span>{(currentPage - 1) * pageSize + index + 1}</span>;
            },
        },
        {
            title: "Name",
            dataIndex: "first_name",
            key: "first_name",
            sorter: true,
            // sorter: (a, b) => a.first_name.length - b.first_name.length,
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            sorter: true,
        },

    ];

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter.order) {
            setSortField(sorter.field);
            setSortOrder(sorter.order === "ascend" ? "asc" : "desc");
        } else {
            setSortField(null);
            setSortOrder(null);
        }
    };


    return (
        <div className="wrapper">
            <div className="container-fluid">
                <div className="row mb-5">
                    <div className="col-md-12">
                        <div className="titleBar d-flex justify-content-between">
                            <h4>Audiences List</h4>
                            <div className="buttonWrap">
                                <button
                                    type="button"
                                    className="btn backBtn"
                                    onClick={() => handleGoBack()}
                                >
                                    <MdArrowBack /> Back
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="tableWrapper">
                            <Table
                                className="productTable"
                                columns={tableColumns}
                                dataSource={isLoading ? [] : audienceData}
                                onChange={handleTableChange}
                                pagination={{
                                    current: currentPage,
                                    pageSize: pageSize,
                                    total: audienceData.length,
                                    onChange: (page, size) => {
                                        setCurrentPage(page);
                                        setPageSize(size);
                                    },
                                    showSizeChanger: true,
                                    showQuickJumper: false,
                                    pageSizeOptions: ["5", "10", "15", "20"],
                                }}
                                loading={isLoading}
                                showSorterTooltip={false}
                                scroll={{ x: 'auto' }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Audienceuser;